export function isMacOSOrWindowsNonEdge() {
  const ua = window.navigator.userAgent;
  const isDesktop = ua.includes("Macintosh") || ua.includes("Windows");
  const isEdge = ua.includes("Edg/");
  return isDesktop && !isEdge;
}
